var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle, accessibilityCompliant: true } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center align-items-center" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center mt-5", attrs: { cols: "12" } },
                    [
                      _c("h5", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("accessibility.page_under_construction")
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }